import React from 'react'
import {  Link } from "react-router-dom";
  function Calltoaction(props){
	return(
		  <>
		  <section id="call-to-action" class="wow fadeInUp">
      <div class="container">
        <div class="row">
          <div class="col-lg-9 text-center text-lg-left">
            <h3 class="cta-title">{props.title}</h3>
            <p class="cta-text">If you prefer to have a thorough, professional hearing test using the latest computerised equipment in the comfort of your own home.</p>
          </div>
          <div class="col-lg-3 cta-btn-container text-center">
          <Link className="cta-btn align-middle" to="/Contact">Contact</Link>
           
          </div>
        </div>

      </div>
    </section>
		  </>
 )
	}
 export default Calltoaction